// Team member data and project content for AIPQ intro page
// Ported from design/aipq/project/components/data.jsx
import { asset } from "./lib/asset";

export type AccentToken = "main" | "point1" | "point2";

export type ProjectThumb =
  | { thumbKind: "simple"; thumbData: { name: string; desc: string; url: string } }
  | { thumbKind: "placeholder"; thumbData?: undefined };

export type MemberProject = {
  title: string;
  subtitle: string;
  desc: string;
  tag: string;
  href?: string;
} & ProjectThumb;

export type MemberLink = { label: string; href: string; icon: string };

export type Member = {
  id: string;
  name: string;
  nameEn: string;
  role: string;
  tagline: string;
  bio: string;
  accent: AccentToken;
  avatar: string;
  links: MemberLink[];
  projects: MemberProject[];
};

export type Project = {
  key: string;
  name: string;
  status: string;
  statusColor: AccentToken;
  tagline: string;
  oneLiner: string;
  bullets: string[];
  cta: { label: string; href: string };
};

export type FootstepItem = {
  title: string;
  url?: string;
  href?: string;
  status?: string;
  summary: string;
  detail?: string;
  screenshot?: string;
};

export type FootstepGroup = {
  key: string;
  label: string;
  labelEn: string;
  accent: AccentToken;
  parent?: string;
  items: FootstepItem[];
};

export const TEAM: Member[] = [
  {
    id: "member-bob",
    name: "Bob",
    nameEn: "이성수",
    role: "Founder · CEO",
    tagline: "핵심 서비스의 메인 아이디어와 가이던스",
    bio: "삶을 견인하는 가장 큰 가치는 재미와 즐거움이라고 믿습니다. 재미있고 즐거운 투자를 위한 서비스를 만듭니다.",
    accent: "main",
    avatar: "B",
    links: [
      { label: "LinkedIn", href: "#", icon: "link" },
      { label: "Email", href: "mailto:bob@aipq.kr", icon: "mail" },
    ],
    projects: [
      {
        title: "Vibe Invest · 제품 비전",
        subtitle: "Founder · 2026",
        desc: "\"재미있는 투자\"라는 축 하나로 자연어 전략 빌더 · 커뮤니티 · 투자 페르소나까지 하나의 제품으로 묶음.",
        tag: "Leading",
        thumbKind: "placeholder",
      },
      {
        title: "(추후 공개) 프로젝트 2",
        subtitle: "Coming soon",
        desc: "프로젝트 설명이 이곳에 표시됩니다. 실제 내용과 링크는 공개 후 업데이트됩니다.",
        tag: "Placeholder",
        thumbKind: "placeholder",
      },
    ],
  },
  {
    id: "member-josh",
    name: "Josh",
    nameEn: "김민석",
    role: "Founding Engineer",
    tagline: "기술 기반 · 자동화 · 솔루션 선택",
    bio: "AI 시대가 올 것이라고 이미 믿고 있던 사람입니다. 망설일 시간에 새로운 것들은 뭐든지 해봅니다.",
    accent: "point1",
    avatar: "J",
    links: [
      { label: "GitHub", href: "#", icon: "code" },
      { label: "LinkedIn", href: "#", icon: "link" },
    ],
    projects: [
      {
        title: "자동화 · 외부 공급 파이프라인",
        subtitle: "Founding Engineer",
        desc: "데이터 수집부터 모델 서빙까지. 제품 단에 들어갈 AI 기능을 실제 사용자가 쓸 수 있는 속도로 운영.",
        tag: "Shipping",
        thumbKind: "placeholder",
      },
      {
        title: "(추후 공개) 프로젝트 2",
        subtitle: "Coming soon",
        desc: "프로젝트 설명이 이곳에 표시됩니다. 실제 내용과 링크는 공개 후 업데이트됩니다.",
        tag: "Placeholder",
        thumbKind: "placeholder",
      },
    ],
  },
  {
    id: "member-chan",
    name: "Chan",
    nameEn: "송치훈",
    role: "Founding Research Engineer",
    tagline: "리서치 · 지식 체계화",
    bio: "목적이 분명하지 않은 기술은 의미가 없습니다. AI 시대가 다가올수록, 인간의 존재가치는 이해와 선택에 있다고 믿습니다.",
    accent: "point2",
    avatar: "C",
    links: [
      { label: "Research", href: "#", icon: "article" },
      { label: "LinkedIn", href: "#", icon: "link" },
    ],
    projects: [
      {
        title: "AIwitness",
        subtitle: "AI 코딩 도구 트래커 · aiwitness.kr",
        desc: "AI 코딩 도구 시장의 움직임을 한 화면에 — 도구 · 가격 · 지표 변화를 실시간 트래킹하는 리서치 사이트.",
        tag: "Live",
        href: "https://aiwitness.kr",
        thumbKind: "simple",
        thumbData: { name: "AIwitness", desc: "AI 코딩 도구 시장의 움직임을 한 화면에 트래킹", url: "aiwitness.kr" },
      },
      {
        title: "(추후 공개) 프로젝트 2",
        subtitle: "Coming soon",
        desc: "프로젝트 설명이 이곳에 표시됩니다. 실제 내용과 링크는 공개 후 업데이트됩니다.",
        tag: "Placeholder",
        thumbKind: "placeholder",
      },
    ],
  },
  {
    id: "member-rae",
    name: "Rae",
    nameEn: "김상래",
    role: "Founding Product Engineer",
    tagline: "컨셉 · Taxonomy · Community",
    bio: "할 수 있으니까 했고, 해봤더니 됐다. 그게 가장 큰 무기라고 믿습니다.",
    accent: "main",
    avatar: "R",
    links: [
      { label: "Portfolio", href: "https://rae-hugo-kim.github.io/portfolio-site/", icon: "captive_portal" },
      { label: "GitHub", href: "#", icon: "code" },
    ],
    projects: [
      {
        title: "황견적",
        subtitle: "PC 견적 추천 서비스 · hgjdev.hugokim.kr",
        desc: "간단한 설문으로 용도 · 예산을 말하면 부품 구성과 가격을 추천.",
        tag: "Live",
        href: "https://hgjdev.hugokim.kr/lite",
        thumbKind: "simple",
        thumbData: { name: "황견적", desc: "간단한 설문으로 PC 견적을 추천", url: "hgjdev.hugokim.kr" },
      },
      {
        title: "(추후 공개) 프로젝트 2",
        subtitle: "Coming soon",
        desc: "프로젝트 설명이 이곳에 표시됩니다. 실제 내용과 링크는 공개 후 업데이트됩니다.",
        tag: "Placeholder",
        thumbKind: "placeholder",
      },
    ],
  },
];

export const PROJECTS: Project[] = [
  {
    key: "copybara",
    name: "Vibe Invest · Copybara",
    status: "In design · Prototype",
    statusColor: "point1",
    tagline: "재미있고 쉬운 투자 커뮤니티 · 투자전략 생성 서비스",
    oneLiner: "퀀트 투자자들의 핵심 커뮤니티",
    bullets: [
      "자연어로 만드는 나만의 투자전략",
      "AI가 배달해주는 따끈따끈한 아침 매거진",
      "영차영차! 함께하는 클랜 시스템",
      "투자 페르소나 찾기 & 투자 페르소나 대결",
    ],
    cta: { label: "프로토타입 열기", href: "https://copybara-pi.vercel.app/" },
  },
  {
    key: "vibe",
    name: "Vibe Invest",
    status: "Prototype",
    statusColor: "main",
    tagline: "자연어로 투자 알고리즘을 만든다",
    oneLiner: "한 줄의 자연어 → 실행 가능한 투자 전략 · 코드 없이",
    bullets: [
      "\"매달 첫째 주 월요일, KODEX 200을 10만원씩 사줘\" 같은 한 줄을 전략으로 변환",
      "변동성 타겟팅, 섹터 로테이션, 모멘텀 등 빌딩블록 제공",
      "거시 데이터, 공시정보 등 통합 데이터 모니터링 솔루션 제공",
    ],
    cta: { label: "프로토타입 열기", href: "https://copybara-pi.vercel.app/" },
  },
];

export const FOOTSTEPS: FootstepGroup[] = [
  {
    key: "live",
    label: "현재 운영중인 서비스",
    labelEn: "Live services",
    accent: "point1",
    items: [
      {
        title: "AIwitness",
        url: "aiwitness.kr",
        href: "https://aiwitness.kr",
        summary: "AI 코딩 도구 시장을 추적하는 리서치 사이트.",
        detail: "AI를 이용한 정보 수집·가공, 웹 페이지 운영에 필요한 SEO/AEO를 실험한다.",
        screenshot: asset("assets/screenshots/aiwitness.png"),
      },
      {
        title: "황견적 (Lite)",
        url: "hgjdev.hugokim.kr/lite",
        href: "https://hgjdev.hugokim.kr/lite",
        summary: "간단한 설문으로 표준화된 PC 견적을 추천하는 서비스.",
        detail: "유저의 진입 문턱을 낮추고, 추후 서비스 확장의 기반을 다진다.",
        screenshot: asset("assets/screenshots/hgjdev.png"),
      },
      {
        title: "Rich or Panic",
        href: "https://30s.indiekit.xyz",
        url: "30s.indiekit.xyz",
        screenshot: asset("assets/screenshots/richorpanic.png"),
        summary: "실제 미국 주식 데이터로 만든 30초 트레이딩 시뮬레이션 게임.",
        detail: "기획 · 개발 · 배포 · 마케팅 · 유지보수 · 보안까지 앱의 생애주기를 체험했다.",
      },
    ],
  },
  {
    key: "game",
    label: "게이미피케이션 및 커뮤니티",
    labelEn: "Gamification & community",
    accent: "main",
    items: [
      {
        title: "Cafe-tf",
        href: "https://cafe.hugokim.kr/",
        summary: "카페 컨셉의 대화형 챗봇으로 구현한 투자성향 테스트.",
        detail: "편안한 분위기의 설문조사 도구를 테스트한다.",
      },
      {
        title: "invti",
        href: "https://invti.hugokim.kr/",
        summary: "MBTI 컨셉으로 풀어낸 흥미로운 투자성향 테스트.",
        detail: "가볍고 흥미로운 테스트로 일반인의 투자성향을 가늠해본다.",
      },
      {
        title: "GyeongdoDay",
        summary: "실외 놀이 \"경도\"를 돕는 Firestore 기반 멀티플레이 모바일 앱.",
        detail: "Zustand · 순수 로직 테스트 · 보안 규칙 · EAS로 소규모 커뮤니티 게임 제품을 경험했다.",
      },
    ],
  },
  {
    key: "data",
    label: "데이터 수집과 이용",
    labelEn: "Data collection & use",
    accent: "point2",
    items: [
      {
        title: "황견적 (Full)",
        status: "WIP",
        href: "https://hgjdev.hugokim.kr/",
        summary: "15,000개가 넘는 부품의 프라이스 매칭이 가능한 PC 견적 서비스.",
        detail: "DB 구축과 운영에 대한 노하우를 쌓기 시작했다.",
      },
      {
        title: "StockGraph",
        href: "https://stockgraph-xi.vercel.app/",
        summary: "종목별 주가변동과 외인 · 기관 순매매 경향을 함께 볼 수 있는 웹앱.",
        detail: "투자 판단에 필요한 흐름을 한 화면에서 비교할 수 있도록 구성했다.",
      },
      {
        title: "Stocker",
        summary: "OpenClaw 봇의 cron으로 관심 종목 동향을 체크하는 개인 투자 대시보드.",
        detail: "매일 주요 경제 뉴스, 거시 현황 draft · 분석을 자동 생성한다.",
      },
      {
        title: "HugoAir",
        summary: "Airgradient 센서를 활용한 실내 공기질 모니터링 대시보드.",
        detail: "API를 활용한 데이터 전달과 활용을 실험한다.",
      },
      {
        title: "우마무스메 로그라이크 대시보드",
        href: "https://uma.hugokim.kr/",
        summary: "디스코드 대회 정보를 자동 수집해 결과와 통계를 제공하는 대시보드.",
        detail: "OpenClaw Bot Peridot와 함께 운영된다.",
      },
    ],
  },
  {
    key: "ai-ops",
    label: "AI에게 더 많은 일을 시키기",
    labelEn: "AI-native · AI workflow",
    accent: "point1",
    parent: "AI-native 역량",
    items: [
      {
        title: "Brainstorming Skill",
        summary: "Claude Code 등에서 구현 전 설계 단계를 강제하는 스킬.",
        detail: "6단계 워크플로우 · fast-track · docs/plans/ · worktree 전환으로 \"설계 먼저\"를 메타 도구화합니다.",
      },
      {
        title: "Nalmuk",
        summary: "VPC · RDS · ECS · Amplify · CodePipeline · GitHub까지 CDK로 한 번에 부트스트랩하는 내부 인프라 도구.",
        detail: "OIDC · 롤백 · DevUnit 에이전트 · TDD PR을 묶어 프로세스 자동화를 IaC로 구현했다.",
      },
      {
        title: "SoloPM",
        summary: "Claude Code 안에서 MCP로 PRD · 티켓 · 진행을 관리하는 솔로 PM 도구.",
        detail: "LangGraph 에이전트 · SQLAlchemy · 모킹 가능한 CI로 AI와 기획을 함께 굴린다.",
      },
      {
        title: "git-atomize",
        summary: "섞인 변경을 LLM이 의미 단위로 나눠 원자적 커밋으로 만드는 Typer CLI.",
        detail: "Map-Reduce · 승인 상태 머신 · 롤백 · 레이어드 DDD · 멀티 프로바이더로 AI 개발 후 커밋을 정리한다.",
      },
      {
        title: "Agent Alert",
        summary: "AI 코딩 에이전트 완료 시 데스크톱 오버레이로 알려주는 Tauri + Go 상주 앱.",
        detail: "hook 한 줄 · API 키 매칭 · 토큰/시간 메타데이터로 에이전트 운영 UX를 다듬는다.",
      },
    ],
  },
  {
    key: "ai-embodied",
    label: "AI와 함께 생활하기",
    labelEn: "AI-native · office & lifestyle",
    accent: "point1",
    parent: "AI-native 역량",
    items: [
      {
        title: "VaultAI",
        summary: "24시간 마이크 녹음 · VAD · 한국어 전사 · 화자 분리 · 요약 · 시맨틱 검색을 잇는 음성 AI 비서.",
        detail: "Claude Desktop 등 MCP로 자연어 질의 · 구간 검색이 가능한 팀/회의 대화 구조화를 지원한다.",
      },
      {
        title: "Chatterbox TTS Server",
        summary: "팀 내부용 GPU 기반 한국어 TTS API (FastAPI · Chatterbox · Docker).",
        detail: "비용 · 지연 · 음성 커스텀을 자체 호스팅으로 해결해 다른 음성 프로젝트의 공통 백엔드로 쓰인다.",
      },
      {
        title: "jigak",
        summary: "늦을 때 대중교통 · 택시 · 하이브리드 경로를 비교 · 안내하는 지각 도우미.",
        detail: "Go 백엔드가 ODsay · 카카오 모빌리티를 조합하고 Pareto 필터 · PostGIS · Redis · 옵저버빌리티까지 엮는다.",
      },
      {
        title: "AIPQ IoT (창문 제어)",
        summary: "ESP8266로 사무실 창문을 제어하는 운영 중 IoT (Google OAuth · PWA · PostgreSQL · Docker).",
        detail: "명령 단일 활성 · 상태 전이 · 감사 로그로 물리 장치와 백엔드를 연결한 풀스택 사례다.",
      },
    ],
  },
  {
    key: "ai-trust",
    label: "LLM을 믿을 수 있게 만들기",
    labelEn: "AI-native · LLM reliability",
    accent: "point1",
    parent: "AI-native 역량",
    items: [
      {
        title: "LLM Agreement",
        summary: "여러 LLM 답변을 claim 단위로 추출 · 클러스터 · 교차 검증 · 합성하는 7단계 합의 엔진.",
        detail: "Trace Ledger(해시 체인) · 역할별 모델 · 웹 검색 · SSE 스트리밍으로 감사 가능한 고신뢰 응답을 만든다.",
      },
      {
        title: "llm-council 포크",
        summary: "Karpathy llm-council 포크로 구조 · 한계를 분석한 OSS 작업.",
        detail: "전체 답변 투표의 한계를 인식해 LLM Agreement의 claim 단위 재설계로 연결했다.",
      },
      {
        title: "Ditto",
        summary: "LLM이 생성하기 쉽고 deny-by-default capability가 있는 에이전트용 실험 언어.",
        detail: "canonical fmt · 2-pass 타입 · 정책 파일로 LLM 코드 생성의 안전성 · 일관성을 언어 차원에서 잡는다.",
      },
      {
        title: "AI Partner",
        summary: "AI 캐릭터 대화를 17단계 파이프라인 · L0 게이트 · pgvector 기억 · 관계 상태로 다루는 베타 엔진.",
        detail: "거짓 기억 · 과잉 친밀을 구조적으로 줄이는 대화형 AI 제품을 만들고 있다.",
      },
    ],
  },
];
